import { render } from "./terminal-info.vue?vue&type=template&id=c18798d8&scoped=true&ts=true"
import script from "./terminal-info.vue?vue&type=script&lang=ts"
export * from "./terminal-info.vue?vue&type=script&lang=ts"

import "./terminal-info.vue?vue&type=style&index=0&id=c18798d8&lang=scss&scoped=true"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c18798d8"]])

export default __exports__